import {RailsPartial} from '@github-ui/rails-partial'
import {pullRequestsChecksRoute} from './checks-route'
import styles from './Checks.module.css'
import {clsx} from 'clsx'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export function ChecksEntrypoint() {
  const updatedHeader = isFeatureEnabled('updated_pull_request_header')
  return (
    <div className={clsx(styles.checksRoot, updatedHeader && 'tmp-pb-3')}>
      <RailsPartial partialName="Main" route={pullRequestsChecksRoute} />
    </div>
  )
}
